import React, { useState } from 'react';

const CART_ITEMS = [
  { id: 1, name: 'Wireless Headphones Pro', price: 4999, qty: 1 },
  { id: 2, name: 'USB Hub 3.0', price: 1299, qty: 2 },
  { id: 3, name: 'Laptop Stand', price: 2499, qty: 1 },
];

const VALID_COUPON = 'SAVE20';
const SHIPPING_OPTIONS = [
  { id: 'std', label: 'Standard Delivery (5-7 days)', cost: 0 },
  { id: 'exp', label: 'Express Delivery (2-day)', cost: 499 },
  { id: 'same', label: 'Same Day Delivery', cost: 999 },
];

const EXPECTED = {
  removedItem: 'USB Hub 3.0',
  coupon: 'SAVE20',
  shipping: 'exp',
  address: '742 Evergreen Terrace, Springfield, IL 62704',
  cardEnding: '4242',
  expiry: '12/28',
};

export default function C13_MultiStepCheckout({ onComplete }) {
  const [step, setStep] = useState(0);
  const [cart, setCart] = useState(CART_ITEMS);
  const [couponInput, setCouponInput] = useState('');
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [shipping, setShipping] = useState('std');
  const [address, setAddress] = useState('');
  const [payment, setPayment] = useState({ type: 'Credit Card', cardNum: '', expiry: '', cvv: '' });
  const [paymentErrors, setPaymentErrors] = useState({});
  const [placed, setPlaced] = useState(false);
  const [answer, setAnswer] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const removeItem = (id) => setCart(c => c.filter(x => x.id !== id));
  const subtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const discount = couponApplied ? Math.round(subtotal * 0.2) : 0;
  const shippingCost = SHIPPING_OPTIONS.find(s => s.id === shipping)?.cost || 0;
  const total = subtotal - discount + shippingCost;

  const applyCoupon = () => {
    if (couponInput.trim().toUpperCase() === VALID_COUPON) {
      setCouponApplied(true); setCouponError('');
    } else {
      setCouponError('Invalid coupon code'); setCouponApplied(false);
    }
  };

  const validatePayment = () => {
    const errs = {};
    if (!payment.cardNum.trim()) errs.cardNum = 'Required';
    if (!payment.expiry.trim()) errs.expiry = 'Required';
    if (!payment.cvv.trim()) errs.cvv = 'Required';
    if (!address.trim()) errs.address = 'Shipping address required';
    return errs;
  };

  const placerOrder = () => {
    const errs = validatePayment();
    if (Object.keys(errs).length) { setPaymentErrors(errs); return; }
    setPlaced(true); setStep(3);
  };

  const handleSubmit = () => {
    if (!answer.trim()) return;
    setSubmitted(true);
    const removedCorrect = !cart.find(i => i.name === EXPECTED.removedItem);
    const couponCorrect = couponApplied && couponInput.trim().toUpperCase() === EXPECTED.coupon;
    const shippingCorrect = shipping === EXPECTED.shipping;
    const addressCorrect = address.trim() === EXPECTED.address;
    const cardCorrect = payment.cardNum.trim().endsWith(EXPECTED.cardEnding);
    const expiryCorrect = payment.expiry.trim() === EXPECTED.expiry;
    const answerCorrect = parseInt(answer.replace(/[^0-9]/g, '')) === total;
    const details = {
      removedUsbHub: { expected: 'Removed', got: removedCorrect ? 'Removed' : 'Still in cart', pass: removedCorrect },
      couponApplied: { expected: EXPECTED.coupon, got: couponInput.trim(), pass: couponCorrect },
      shippingMethod: { expected: 'Express Delivery (2-day)', got: SHIPPING_OPTIONS.find(s => s.id === shipping)?.label, pass: shippingCorrect },
      shippingAddress: { expected: EXPECTED.address, got: address.trim(), pass: addressCorrect },
      cardNumber: { expected: `ending in ${EXPECTED.cardEnding}`, got: payment.cardNum.trim() ? `ending in ${payment.cardNum.trim().slice(-4)}` : 'empty', pass: cardCorrect },
      cardExpiry: { expected: EXPECTED.expiry, got: payment.expiry.trim(), pass: expiryCorrect },
      orderTotal: { expected: `₹${total.toLocaleString()}`, got: answer.trim(), pass: answerCorrect },
    };
    const correct = Object.values(details).filter(d => d.pass).length;
    onComplete({ score: Math.round((correct / 7) * 100), details, passed: correct === 7 });
  };

  const STEPS = ['Cart', 'Shipping', 'Payment', 'Review'];

  return (
    <div className="ab-challenge-ui">
      <div className="ab-checkout-steps">
        {STEPS.map((s, i) => (
          <div key={s} className={`ab-checkout-step ${step === i ? 'active' : ''} ${i < step ? 'done' : ''}`}>
            <div className="ab-checkout-step-num">{i < step ? '✓' : i + 1}</div>
            <span>{s}</span>
          </div>
        ))}
      </div>

      {step === 0 && (
        <div>
          <div className="ab-table-wrap">
          <table className="ab-table">
            <thead><tr><th>Product</th><th>Price</th><th>Qty</th><th>Total</th><th></th></tr></thead>
            <tbody>
              {cart.map(item => (
                <tr key={item.id}>
                  <td><strong>{item.name}</strong></td>
                  <td>₹{item.price.toLocaleString()}</td>
                  <td>{item.qty}</td>
                  <td>₹{(item.price * item.qty).toLocaleString()}</td>
                  <td><button className="ab-btn-danger-sm" onClick={() => removeItem(item.id)}>Remove</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          <div className="ab-coupon-row">
            <input value={couponInput} onChange={e => { setCouponInput(e.target.value); setCouponError(''); }}
              className={`ab-input${couponError ? ' ab-input-err' : ''}`} placeholder="Enter coupon code" />
            <button className="ab-action-btn ab-action-btn-sm" onClick={applyCoupon}>Apply</button>
            {couponApplied && <span className="ab-coupon-ok">✓ 20% discount applied!</span>}
            {couponError && <span className="ab-field-err">{couponError}</span>}
          </div>
          <div className="ab-cart-summary">
            <div>Subtotal: <strong>₹{subtotal.toLocaleString()}</strong></div>
            {couponApplied && <div className="ab-discount-line">Discount (20%): <strong>-₹{discount.toLocaleString()}</strong></div>}
          </div>
          <button className="ab-action-btn" onClick={() => setStep(1)}>Continue to Shipping →</button>
        </div>
      )}

      {step === 1 && (
        <div>
          <div className="ab-field">
            <label className="ab-label">Shipping Address *</label>
            <input value={address} onChange={e => setAddress(e.target.value)}
              className={`ab-input${paymentErrors.address ? ' ab-input-err' : ''}`} placeholder="Street, City, State ZIP" />
            {paymentErrors.address && <span className="ab-field-err">{paymentErrors.address}</span>}
          </div>
          <div className="ab-shipping-options">
            {SHIPPING_OPTIONS.map(opt => (
              <label key={opt.id} className={`ab-shipping-opt ${shipping === opt.id ? 'ab-shipping-opt-active' : ''}`}>
                <input type="radio" name="shipping" value={opt.id} checked={shipping === opt.id} onChange={() => setShipping(opt.id)} />
                <span>{opt.label}</span>
                <span className="ab-shipping-cost">{opt.cost === 0 ? 'FREE' : `₹${opt.cost}`}</span>
              </label>
            ))}
          </div>
          <div className="ab-step-nav">
            <button className="eval-btn" onClick={() => setStep(0)}>← Back</button>
            <button className="ab-action-btn" onClick={() => { setPaymentErrors({}); setStep(2); }}>Continue to Payment →</button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div>
          <div className="ab-field">
            <label className="ab-label">Payment Method</label>
            <select value={payment.type} onChange={e => setPayment(p => ({ ...p, type: e.target.value }))} className="ab-input">
              {['Credit Card', 'Debit Card', 'Net Banking', 'UPI'].map(v => <option key={v}>{v}</option>)}
            </select>
          </div>
          {(payment.type === 'Credit Card' || payment.type === 'Debit Card') && (
            <div className="ab-form-grid-2">
              <div className="ab-field" style={{ gridColumn: '1 / -1' }}>
                <label className="ab-label">Card Number (last 4 digits)</label>
                <input value={payment.cardNum} onChange={e => setPayment(p => ({ ...p, cardNum: e.target.value }))}
                  className={`ab-input${paymentErrors.cardNum ? ' ab-input-err' : ''}`} placeholder="XXXX XXXX XXXX XXXX" />
                {paymentErrors.cardNum && <span className="ab-field-err">{paymentErrors.cardNum}</span>}
              </div>
              <div className="ab-field">
                <label className="ab-label">Expiry Date</label>
                <input value={payment.expiry} onChange={e => setPayment(p => ({ ...p, expiry: e.target.value }))}
                  className={`ab-input${paymentErrors.expiry ? ' ab-input-err' : ''}`} placeholder="MM/YY" />
                {paymentErrors.expiry && <span className="ab-field-err">{paymentErrors.expiry}</span>}
              </div>
              <div className="ab-field">
                <label className="ab-label">CVV</label>
                <input type="password" value={payment.cvv} onChange={e => setPayment(p => ({ ...p, cvv: e.target.value }))}
                  className={`ab-input${paymentErrors.cvv ? ' ab-input-err' : ''}`} placeholder="•••" maxLength={3} />
                {paymentErrors.cvv && <span className="ab-field-err">{paymentErrors.cvv}</span>}
              </div>
            </div>
          )}
          <div className="ab-step-nav">
            <button className="eval-btn" onClick={() => setStep(1)}>← Back</button>
            <button className="ab-action-btn" onClick={placerOrder}>Review Order →</button>
          </div>
        </div>
      )}

      {step === 3 && placed && (
        <div>
          <div className="ab-order-review">
            <h4>Order Summary</h4>
            <div className="ab-review-row"><span>Items:</span><span>{cart.map(i => i.name).join(', ')}</span></div>
            <div className="ab-review-row"><span>Subtotal:</span><span>₹{subtotal.toLocaleString()}</span></div>
            {couponApplied && <div className="ab-review-row ab-discount-row"><span>Discount (20%):</span><span>-₹{discount.toLocaleString()}</span></div>}
            <div className="ab-review-row"><span>Shipping ({SHIPPING_OPTIONS.find(s => s.id === shipping)?.label}):</span><span>{shippingCost === 0 ? 'FREE' : `₹${shippingCost}`}</span></div>
            <div className="ab-review-row ab-total-row"><span><strong>Total:</strong></span><span><strong className="ab-total-val">₹{total.toLocaleString()}</strong></span></div>
          </div>
          <div className="ab-answer-row">
            <label className="ab-label">Enter the final order total shown above:</label>
            <input value={answer} onChange={e => setAnswer(e.target.value)} className="ab-input ab-answer-input"
              placeholder="e.g. 8,099" disabled={submitted} />
            {!submitted
              ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Answer</button>
              : <div className="ab-submitted-badge">✓ Submitted — Evaluating...</div>
            }
          </div>
        </div>
      )}
    </div>
  );
}
